import type {DocumentNode} from "graphql";
import gql from "graphql-tag";

export const PROGRAM_FRAGMENT: DocumentNode = gql`
    fragment Program on Program {
        id
        latestRevision {
            id
            code
        }
        title
        url
        userAuthoredContentType
    }
`;
